import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  cardRoot: {
    backgroundColor: theme.palette.blue.lightest,
    height: '100%',
    minHeight: '400px',
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '600px',
  },
  cardHeader: {
    alignItems: 'baseline',
    display: 'flex',
    marginLeft: theme.spacing(2),
  },
  titleCA: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '21.09px',
    marginRight: theme.spacing(1),
  },
  valueCA: {
    fontSize: 18,
    fontWeight: 700,
    lineHeight: '21.09px',
  },

  cardTitle: {
    marginLeft: theme.spacing(3),
  },
  cardLoading: {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
  cardContent: {
    backgroundColor: 'white',
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  graphContainer: {
    flexGrow: 1,
    marginTop: theme.spacing(3),
  },
  infoCards: {
    marginTop: theme.spacing(8),
    justifyContent: 'center',
  },
  infoCardContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '250px',
    minWidth: '250px',
    padding: theme.spacing(2),
  },
  lastInfoCardContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  infoCard: {
    backgroundColor: theme.palette.blue.lightest,
    height: '150px',
    textAlign: 'center',
    width: '100%',
  },
  infoCardTitle: {
    fontStyle: 'italic',
    fontSize: 18,
    marginBottom: theme.spacing(2),
    overflow: 'visible',
  },
  infoCardContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'flex-end',
  },
  infoCardSubTitle: {
    fontSize: 18,
    fontWeight: 400,
    fontStyle: 'italic',
    lineHeight: '21.09px',
    overflow: 'visible',
  },
  infoCardValue: {
    fontSize: 18,
    fontWeight: 700,
    fontStyle: 'italic',
    lineHeight: '21.09px',
    color: theme.palette.primary.main,
    width: 120,
    //marginTop: theme.spacing(3),
  },
  infoCardBigValue: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '28.13px',
  },
  mostSelledValueContainerLeft: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'initial',
    marginBottom: theme.spacing(2),
    width: '50%',
  },
  mostSelledValueContainerRight: {
    flexDirection: 'column',
    alignContent: 'flex-end',
    textAlign: 'center',
  },
  starContent: {
    alignItems: 'baseline',
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '80%',
  },
}));
